// extracted by mini-css-extract-plugin
export var section = "_2n-1";
export var topNav = "_2n-0";